<script setup>
const props = defineProps({
    // The consent is being recorded; the embed loads once it is.
    saving: {
        type: Boolean,
        default: false,
    },
    failed: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['consent']);
</script>

<template>
    <div class="flex flex-col items-center justify-center gap-4 p-8 text-center rounded-wl bg-gray-50 border border-gray-200">
        <p class="text-sm text-gray-700">
            <mf-translate domainkey="cookieBanner:nonEssentialCookiesRequired"></mf-translate>
        </p>
        <button-primary size="sm" :disabled="props.saving" :state="props.saving ? 'waiting' : ''" @click="emit('consent')">
            <mf-translate domainkey="cookieBanner:consentToNonEssentialCookies"></mf-translate>
        </button-primary>
        <p v-if="props.failed" class="text-xs text-myflowRed" role="alert">
            <mf-translate domainkey="cookieBanner:saveFailed"></mf-translate>
        </p>
    </div>
</template>
